export enum TreeCategoryType {
  DROPDOWN = 'DROPDOWN',
  DRAWER = 'DRAWER'
}
